import { ParagraphFilterModel } from "./../paragraph-filter";
import { DocumentEvents } from "./../../helpers/document-events";
import { CaseDocumentModel } from "./../case-document";
import { IDocumentRequestOptions } from "./../../interfaces/document-request-options";
import { AuthorizationModel } from "./../../../authentication/models/authorization-model";
import { AppSettings } from "./../../../app-settings";
import { DisplayKeyParagraphCollection } from "./../../collections/display-key-paragraphs";
import { JudgmentTabState } from "./judgment-tab-state";
import { GenericTabModel } from "./generic-tab";
import { FulltextTabModel } from "./fulltext";
import {prop} from "../../../decorators/property";

export class JudgmentTabModel extends FulltextTabModel {

    @prop() public Data: CaseDocumentModel; // Specify this kind of document model specifically as it has a considered collection which we need for CIC
    // As we add EU docs we could move to using an interface SupportsCIC which ensures the model has a "Considered" collection
    // Or we could instead transmit the relevant collection with the event trigger, entirely circumventing this issue

    @prop() public State: JudgmentTabState = new JudgmentTabState();
    @prop() public DisplayQuotedParagraphs: DisplayKeyParagraphCollection;

    public loadQuotedParagraphs(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (this.DisplayQuotedParagraphs) {
                resolve();
            } else {
                const collection = new DisplayKeyParagraphCollection();
                collection.fetchRequest({
                    url: AppSettings.ApiUrlPrefix + "keyparagraphs/quoted/" + this.Data.id,
                    beforeSend: AuthorizationModel.attachAuthorizationHeader,
                    success: () => {
                        this.DisplayQuotedParagraphs = collection; // Does this need to be on the state?
                        resolve();
                    },
                    error: (err) => {
                        dev.log(`Error loading quoted key paragraphs for document ${this.Data.id}`);
                        dev.log("%s: %s", err.status, err.responseText);
                        reject();
                    }
                });
            }
        });
    }

    public applyUIStateOptions(options: IDocumentRequestOptions) {
        if (!options) {
            this.State.ParagraphFilters.reset();
            this.State.ShowAllQuotes = false;
            this.State.ShowPowerPara = false;
            return;
        }

        if (options.paragraphFilter) {
            const cited = new Backbone.Collection();
            cited.add(this.Data.Considered.models);

            const newClass = this.State.addOrRemoveParagraphFilter(options.paragraphFilter, cited);
            this.Data.trigger(DocumentEvents.CICEngaged, {Class: newClass, Id: options.paragraphFilter});
        }

        if (options.paragraphNumber) {
            this.State.ParagraphNumber = options.paragraphNumber;
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/judgment.ts